import { InjectionToken, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/// Uygulamanın kullandığı depo yüzeyi. Prerender (Node) sırasında
/// `localStorage` yoktur; kod doğrudan `localStorage` yerine bu jetonu
/// kullanır. Tarayıcıda gerçek depo, sunucuda boş bellek içi depo
/// (oturum yok = ziyaretçi görünümü; prerender HTML'i herkes için aynı).
export type SimpleStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem' | 'clear'>;

export class MemoryStorage implements SimpleStorage {
  private readonly data = new Map<string, string>();

  getItem(key: string): string | null {
    return this.data.get(key) ?? null;
  }

  setItem(key: string, value: string): void {
    this.data.set(key, String(value));
  }

  removeItem(key: string): void {
    this.data.delete(key);
  }

  clear(): void {
    this.data.clear();
  }
}

export const BROWSER_STORAGE = new InjectionToken<SimpleStorage>('BROWSER_STORAGE', {
  providedIn: 'root',
  factory: () => {
    if (!isPlatformBrowser(inject(PLATFORM_ID))) {
      return new MemoryStorage();
    }
    try {
      return window.localStorage;
    } catch {
      // Safari gizli mod / engellenmiş site verisi: sayfa yine açılsın.
      return new MemoryStorage();
    }
  },
});
